export default "__VITE_ASSET__C896$Y_S__"